import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { FolderKanban, TrendingDown, Users, DollarSign } from "lucide-react";

const stats = [
  { icon: FolderKanban, value: "7+", label: "tools compared" },
  { icon: DollarSign, value: "$3.50", label: "lowest per-user" },
  { icon: TrendingDown, value: "85%", label: "productivity boost" },
  { icon: Users, value: "10K+", label: "teams surveyed" },
];

export const PMToolsHeroSection = () => {
  return (
    <section className="pt-20 sm:pt-24 pb-8">
      <div className="space-y-6">
        {/* Category badge */}
        <Badge variant="secondary" className="text-sm font-medium">
          Productivity
        </Badge>

        {/* Title */}
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground leading-tight">
          Project Management Tools: Complete Comparison Guide
        </h1>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl">
          Lottae vs Asana vs Monday vs Trello vs Jira — find the best tool for your team's workflow and budget
        </p>

        {/* Meta info */}
        <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
          <span>Published January 26, 2025</span>
          <span className="hidden sm:inline">•</span>
          <span>11 min read</span>
          <Badge variant="outline" className="bg-primary/10 text-primary border-primary/20">
            New
          </Badge>
        </div>

        {/* Stats cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 pt-4">
          {stats.map((stat) => (
            <Card key={stat.label} className="bg-card/50 border-border/50">
              <CardContent className="p-4 flex items-center gap-3">
                <div className="p-2 rounded-lg bg-primary/10">
                  <stat.icon className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="text-xl sm:text-2xl font-bold text-foreground">{stat.value}</p>
                  <p className="text-xs sm:text-sm text-muted-foreground">{stat.label}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
